var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legal-texts-contract-revisions-index-view"
  }, [_c('search-input', {
    ref: "search",
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), (_vm.gridLoaded) ? _c('data-grid', {
    staticClass: "uk-margin-medium",
    attrs: {
      "columns": _vm.gridColumns,
      "is-loading": _vm.isLoading,
      "page-info": _vm.paginate,
      "rows": _vm.entries,
      "sort-info": _vm.sort,
      "sortable": ['name', 'contractNumber', 'validFrom', 'validUntil', 'updatedAt']
    },
    on: {
      "sort": _vm.sortBy
    },
    scopedSlots: _vm._u([{
      key: "row",
      fn: function(props) {
        return [_c('td', [_c('router-link', {
          attrs: {
            "to": {
              name: 'edit-contract-revision',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v(_vm._s(props.row.contract.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.contract.contractNumber))]), _vm._v(" "), _c('td', [_c('validity', {
          attrs: {
            "value": props.row.validFrom
          }
        })], 1), _vm._v(" "), _c('td', [_c('validity', {
          attrs: {
            "value": props.row.validFrom
          }
        })], 1), _vm._v(" "), _c('td', [(props.row.updatedAt) ? _c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": props.row.updatedAt
          }
        }) : _c('text-placeholder')], 1), _vm._v(" "), _c('td', [_c('data-grid-actions', {
          attrs: {
            "edit-route": {
              name: 'edit-contract-revision',
              params: {
                id: props.row.id
              }
            },
            "removable": false
          }
        })], 1)]
      }
    }])
  }, [_c('span', {
    slot: "empty"
  }, [_vm._v(_vm._s(_vm.$t('hints.empty')))])]) : _c('div', {
    staticClass: "loader-container uk-container uk-margin-medium-top uk-text-center"
  }, [_c('loader')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fd9d374","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/LegalTexts/ContractRevisionsIndexView.vue
// module id = 1895
// module chunks = 0